import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { MDBContainer } from "mdbreact";
import Headers from './Components/Headers';
import Home from './Pages/Home';
import Addpetition from './Pages/addpetition';
import Datarubrong from './Pages/datarubrong';
import Showcertificate from './Pages/showcertificate';
import Showcertificatehistory from './Pages/showcertificatehistory';
import ShowcertificateHeadtabian from './Pages/showcertificateHeadtabian';
import ShowcertificateHeadtabianhistory from './Pages/showcertificateHeadtabianhistory';
import ShowcertificateVicerector from './Pages/showcertificateVicerector';
import Showreason from './Pages/showreason';
import Checklogin from './Pages/checklogin';
import AddNumberRobrong from './Pages/addnumberrobrong';
import ShowSJCODERubrong from './Pages/showsjcoderubrong';
import AddDateJob from './Pages/adddatejob';

import ShowcertificateTeacher from './Pages/showcertificateTeacher';
import SsoCallback from './Pages/SsoCallback';

export default class Routes extends Component {
    render() {
        const loggedIn = !!localStorage.getItem('checkstatus');
        const routes = (
            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/sso" component={SsoCallback} />
                <Route exact path="/sso/:id" component={SsoCallback} />
                <Route exact path="/Checklogin/:id" component={Checklogin} />
{/* เด็ก */}
                <Route exact path="/Addpetition" component={Addpetition} />
                <Route exact path="/Datarubrong" component={Datarubrong} />
{/* ทะเบียน */}
                <Route exact path="/Showcertificate" component={Showcertificate} />
                <Route exact path="/Showcertificatehistory" component={Showcertificatehistory} />
                <Route exact path="/Showreason" component={Showreason} />
                <Route exact path="/AddNumberRubrong" component={AddNumberRobrong} />
                <Route exact path="/ShowSJCODERubrong" component={ShowSJCODERubrong} />
                <Route exact path="/AddDateJob" component={AddDateJob} />
{/* นายทะเบียน */}
                <Route exact path="/ShowcertificateHeadtabian" component={ShowcertificateHeadtabian} />
                <Route exact path="/ShowcertificateHeadtabianhistory" component={ShowcertificateHeadtabianhistory} />
{/* รอง */}
                <Route exact path="/ShowcertificateVicerector" component={ShowcertificateVicerector} />
{/* อาจารย์ */}
                <Route exact path="/ShowcertificateTeacher" component={ShowcertificateTeacher} />
            </Switch>
        );

        return (
            <Router basename="rubrongkpru">
                {loggedIn ? (
                    <div className="app-shell">
                        <Headers />
                        <main className="app-main">
                            <MDBContainer fluid>
                                {routes}
                            </MDBContainer>
                        </main>
                    </div>
                ) : routes}
            </Router>
        );
    }
}